import { Component, Input,  OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HistoricalSalesDTO, HistoricalSalesInputDTO, HostPortalClient, WebinarRoom, WebinarRoomOwnerDTO, WebinarRunningStatus } from 'src/app/Services/WOWApi.Service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { VideoPopupComponent } from 'src/app/Shared/video-popup/video-popup.component';
import { ShareWebinarDialogComponent } from '../share-webinar-dialog/share-webinar-dialog.component';

@Component({
    selector: 'app-webinar-historical',
    templateUrl: './webinar-historical.component.html',
    styleUrls: ['./webinar-historical.component.css'],
    standalone: false
})
export class WebinarHistoricalComponent implements OnInit {
historicalData:HistoricalSalesDTO[];
@ViewChild(MatAccordion) accordion: MatAccordion;
range: UntypedFormGroup;
input:HistoricalSalesInputDTO;
statuses: WebinarRunningStatus[];
roomId:number = 0;
startDate:Date;
endDate:Date;
totalCost:number = 0 ;
today = new Date(); 
@Input() webinarRooms: WebinarRoomOwnerDTO[];
  constructor(private hostPortalClient:HostPortalClient,

    private commonServices: CommonServices,
    private customServices: CustomServiceService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar) { }
    
  ngOnInit(): void {   
    this.CreateForm();
    this.GetStatus();
    // this.GetData();
  }
 

  GetStatus()
  {
     this.hostPortalClient.getStatuses().subscribe(x =>  {
        this.statuses = x;
        const statusIds = this.statuses.map(status => status.id);
        this.range.controls.status.setValue(statusIds);
        this.range.controls.webinarRoom.setValue(this.webinarRooms[0].webinarRoomId);
        this.GetData(); 
     });
  }

  CreateForm()
  {
    this.range = new UntypedFormGroup({
      start: new UntypedFormControl(new Date(moment().subtract(1, 'month').toDate())),
      end: new UntypedFormControl(new Date()),
      status: new UntypedFormControl(''),
      webinarRoom : new UntypedFormControl(''),

    });
    this.range.controls.start.setValidators(Validators.required);
    this.range.controls.end.setValidators(Validators.required);
    this.range.controls.status.setValidators(Validators.required);
  }
  GetFormData() {
    this.input = new HistoricalSalesInputDTO();
    this.input.webinarRoomId = this.range.controls["webinarRoom"].value;
    this.input.startDate =  this.range.controls["start"].value;
    this.input.endDate = this.range.controls["end"].value;
    this.input.statusId = this.range.controls["status"].value;
     
  }

  GetData() {
    this.GetFormData();
    console.log(this.input);
    this.hostPortalClient.getHistoricalData(this.input)
     .subscribe(x => {
      this.historicalData = x;
      this.GetTotal();
    });
  }
  GetTotal(){
    this.totalCost  = 0;
    if(this.historicalData.length > 0)
    {

      return this.historicalData.forEach(x => {
        this.totalCost = this.totalCost +  x.cost ;
      });
    }
  }

  hasVideo(webinar: HistoricalSalesDTO): boolean {
    return !!webinar.videoRecordingPath;
  }

  openWatch(webinar: HistoricalSalesDTO): void {
    this.dialog.open(VideoPopupComponent, VideoPopupComponent.openConfig({ videoPath: webinar.videoRecordingPath }));
  }

  openShare(webinar: HistoricalSalesDTO): void {
    const hostUser = this.customServices.GetLoggedInUser();
    const dialogRef = this.dialog.open(ShareWebinarDialogComponent, {
      width: '500px',
      data: { webinarId: webinar.webinarId, hostUserId: hostUser?.id, seats: webinar.webinarSeats }
    });

    dialogRef.afterClosed().subscribe((sentCount: number) => {
      if (sentCount) {
        this.snackBar.open(`Rewatch link sent to ${sentCount} recipient${sentCount === 1 ? '' : 's'}.`, 'Close', { duration: 4000 });
      }
    });
  }

}
